import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import loadingAnimation from "../loadingAnimation.json"
import Lottie from "lottie-react";
export default function Movies() {
  const [popularMovies, setPopularMovies] = useState([]);
  const [topRatedMovies, setTopRatedMovies] = useState([]);
  const [upcomingMovies, setUpcomingMovies] = useState([]);
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate();
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0ZmZhM2UxNGQ0ZjMxOTg1NDk5NGE0ZjRjM2I0ODYwOCIsInN1YiI6IjY1NmNhNzlmZTM4YmQ4MDEzODU3MTRjZiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.dj5HiwpguntzVOpJVHY1sQ7emIQuESxWfM09tKqS9Ss",
    },
  };

  useEffect(() => {
    // Fetch Popular Movies
    fetch(
      "https://api.themoviedb.org/3/movie/popular?language=en-US&page=1&region=India",
      options
    )
      .then((response) => response.json())
      .then((data) => setPopularMovies(data.results))
      .catch((err) => console.error(err));

    // Fetch Top Rated Movies
    fetch(
      "https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1",
      options
    )
      .then((response) => response.json())
      .then((data) => setTopRatedMovies(data.results))
      .catch((err) => console.error(err));

    // Fetch Upcoming Movies
    fetch(
      "https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1",
      options
    )
      .then((response) => response.json())
      .then((data) => setUpcomingMovies(data.results))
      .then(()=>setLoading(false))
      .catch((err) => console.error(err));
  }, []);
  if(loading){
    return <div className="flex items-center justify-center h-screen">
      <Lottie className="pl-20" animationData={loadingAnimation} height={50} width={50}></Lottie>
    </div>
  }

  return (
    <div className="bg-[#221F1F]">
    {/* Popular Movies */}
    <div>
      <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
        Popular
      </div>
     
      <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar ">
        {popularMovies.map((movie) => (
          <img
            key={movie.id}
            className="w-40 rounded-sm hover:cursor-pointer"
            src={movie.poster_path ? `https://image.tmdb.org/t/p/original/${movie.poster_path}` : 'https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg'}
            alt={movie.title}
            title={movie.title + ' (' + movie.release_date.slice(0, 4) + ')'}
            onClick={() => navigate(`/playvideo/movie/${movie.id}`)}
          />
        ))}
      </div>
    </div>

    {/* Top Rated Movies */}
    <div>
      <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
        Top Rated
      </div>
      <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar">
        {topRatedMovies.map((movie) => (
          <img
            key={movie.id}
            className="w-40 rounded-sm hover:cursor-pointer"
            src={movie.poster_path ? `https://image.tmdb.org/t/p/original/${movie.poster_path}` : 'https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg'}
            alt={movie.title}
            title={movie.title + ' (' + movie.release_date.slice(0, 4) + ')'}
            onClick={() => navigate(`/playvideo/movie/${movie.id}`)}
          />
        ))}
      </div>
    </div>

    {/* Upcoming Movies */}
    <div className="pb-5">
      <div className="text-[#867d7d] font-sans font-bold p-3 text-left">
        Upcoming
      </div>
      <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar lg:text-white lg:font-poppins">
        {upcomingMovies.map((movie) => (
              <img
                key={movie.id}
                className="w-40 rounded-sm hover:cursor-pointer"
                src={movie.poster_path ? `https://image.tmdb.org/t/p/original/${movie.poster_path}` : 'https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg'}
                alt={movie.title}
                title={movie.title + ' (' + movie.release_date.slice(0, 4) + ')'}
                onClick={() => navigate(`/playvideo/movie/${movie.id}`)}
              />
        ))}
      </div>
    </div>
  </div>
  )
}
